var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionBtnLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0Z",
    fill: "#DFE5F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 30H29.485M29.5 38.5714H29.485M29.5 21.4286H29.485M28 30C28 29.211 28.6716 28.5714 29.5 28.5714C30.3284 28.5714 31 29.211 31 30C31 30.789 30.3284 31.4286 29.5 31.4286C28.6716 31.4286 28 30.789 28 30ZM28 21.4286C28 20.6396 28.6716 20 29.5 20C30.3284 20 31 20.6396 31 21.4286C31 22.2176 30.3284 22.8571 29.5 22.8571C28.6716 22.8571 28 22.2176 28 21.4286ZM28 38.5714C28 37.7825 28.6716 37.1429 29.5 37.1429C30.3284 37.1429 31 37.7825 31 38.5714C31 39.3604 30.3284 40 29.5 40C28.6716 40 28 39.3604 28 38.5714Z",
    stroke: "#181D24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionBtnLight);
export default __webpack_public_path__ + "static/media/optionBtnLight.6ed8f7700541893a302072947db6c4ad.svg";
export { ForwardRef as ReactComponent };